import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./ui/App.js";
import { bootstrap } from "./state/storage.js";
import { loadGameCards } from "./state/game-cards.js";
import { initAutoSync } from "./state/auto-sync.js";
import { handleOAuthRedirectIfPopup } from "./platform/identity/google-identity.js";
import "./index.css";

/**
 * Entry point. Opens the local DB and seeds first-run defaults (decision #1
 * local-first) BEFORE the first render, so the UI never flashes an empty state
 * while storage initializes. The PWA service worker is auto-registered by
 * vite-plugin-pwa (decision #1).
 */
async function main() {
  // OAuth 팝업 콜백 처리(결정 #8): 이 창이 Google 리다이렉트 팝업이면 opener로 code를
  // 전달하고 닫는다. 앱을 렌더하지 않고 즉시 종료(팝업은 인증 전달 전용).
  if (handleOAuthRedirectIfPopup()) return;

  const rootEl = document.getElementById("root");
  if (!rootEl) throw new Error("#root not found");

  try {
    await bootstrap();
    // 저장된 데이터형 게임 카드를 컴파일·등록한다(결정 #29). 부팅 실패와 분리해
    // 카드 로드가 실패해도 앱은 뜨도록 try 안에 두되 개별 카드 오류는 내부에서 격리된다.
    await loadGameCards();
  } catch (e) {
    // Storage can fail in private mode / blocked IndexedDB. Surface it rather
    // than rendering a half-initialized app.
    console.error("Storage bootstrap failed", e);
    rootEl.innerHTML =
      '<div style="padding:24px;font-family:sans-serif;color:#e8e8f0">저장소를 초기화할 수 없습니다. 브라우저의 시크릿 모드이거나 저장소가 차단된 경우 발생할 수 있어요.</div>';
    return;
  }

  createRoot(rootEl).render(
    <StrictMode>
      <App />
    </StrictMode>,
  );

  // 자동 동기화 관찰 시작(결정 #20). 첫 페인트를 막지 않도록 렌더 뒤에 fire-and-forget.
  // Google 미설정/미연결이면 내부 게이트(isEnabled)가 막아 실제로는 돌지 않고,
  // 연결되는 순간부터 변경에 반응한다. 초기화 실패가 앱을 죽이지 않게 흡수한다.
  void initAutoSync().catch((e) => console.warn("auto-sync init failed", e));
}

void main();
